import { render, staticRenderFns } from "./TotalCard.vue?vue&type=template&id=d97dcba4&"
import script from "./TotalCard.vue?vue&type=script&lang=js&"
export * from "./TotalCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports